<template>
  <div class="dashboard-block" @click="goTo()">
    <div class="d-flex flex-column align-items-center">
      <div class="d-flex align-items-center justify-content-between w-100">
        <small-title
            class="flex-grow-1"
            no_margin
            :text="title"/>
        <div class="dashboard-block__block">
          <img :src="image"  class="dashboard-block__image">
        </div>
      </div>
      <hr style="width: 100%">
      <slot></slot>
    </div>
  </div>
</template>

<script>

import InfoIcon from "../../components/icons/InfoIcon";
import CloseIcon from "../../components/icons/CloseIcon";
import SmallTitle from "./SmallTitle.vue";
export default {
  name: "DashboardBlock",
  components: {SmallTitle, CloseIcon, InfoIcon},
  props: {
    title: {
      String,
      default: ''
    },
    image: {
      String,
      default: ''
    },
    route: {
      String,
      default: false
    },
    hide_info_icon: {
      type: Boolean,
      default: false
    },
    can_close: {
      type: Boolean,
      default: false
    },
  },
  computed: {
    component_classes() {
      return {
      }
    }
  },
  data() {
    return {
      visible: true,
    }
  },
  methods: {
    goTo() {
      if (this.route) {
        this.$router.push({name: this.route})
      }
    }
  }
}
</script>
